export default {
  data() {
    return {
      scrollTop: 0,
    };
  },
  methods: {
    updateScroll(e) {
      var scroller = this.$refs.scroll;
      scroller = scroller?.$el || scroller;
      if (scroller) {
        this.scrollTop = scroller.scrollTop;
      }
    },
  },
  mounted() {
    var scroller = this.$refs.scroll;
    scroller = scroller?.$el || scroller;
    if (scroller) {
      scroller.addEventListener("scroll", this.updateScroll);
    }
  },
  beforeUnmount() {
    var scroller = this.$refs.scroll;
    scroller = scroller?.$el || scroller;
    if (scroller) {
      scroller.removeEventListener("scroll", this.updateScroll);
    }
  },
  activated() {
    var scroller = this.$refs.scroll;
    scroller = scroller?.$el || scroller;
    if (scroller) {
      scroller.scrollTop = this.scrollTop;
    }
  },
};
